// @flow
import * as React from 'react';
import styled from 'styled-components';

type TProps = {
  children: string | React.Node,
  color?: string,
  centered?: boolean,
  family?: string,
};

const StyledHeader1 = styled.h1`
  font-family: ${props => props.family || 'InterRegular'};
  line-height: 1.4;
  font-size: 24px;
  margin: 0;
  color: ${props => props.color || '#000'};
  text-align: ${props => props.centered ? 'center' : 'left'};
`;

export default function TextHeader1(props: TProps): React.Node {
  return (
    <StyledHeader1 {...props}>
      {props.children}
    </StyledHeader1>
  );
}
